import {DropMenu} from './drop-menu';
import {BUTTON_STYLE_MAIN_FLEX} from './styles';

interface MediaDeviceSelectorProps {
  title: string;
  deviceList: MediaDeviceInfo[];
  onSelectDevice: (device: MediaDeviceInfo) => void;
  loadDeviceList: () => Promise<void>;
}

export function MediaDeviceSelector({title, deviceList, onSelectDevice, loadDeviceList}: MediaDeviceSelectorProps) {
  const deviceDropdownItems = deviceList.map(device => ({
    value: device.label,
    callback: () => onSelectDevice(device),
  }));

  return (
    <DropMenu
      label={title}
      items={deviceDropdownItems}
      style={BUTTON_STYLE_MAIN_FLEX}
      onClick={() => void loadDeviceList()}
    />
  );
}
